import { useState } from 'react';

import ContactModal from './ContactModal';

/**
 * ContactLink component - styled link that opens ContactModal
 * Replaces Calendly links throughout the application
 *
 * @param {string} children - Link text content (default: "Schedule Your Meeting")
 * @param {object} style - Optional inline styles to apply
 * @param {string} className - Optional CSS class name
 * @returns {React.Component} ContactLink component with modal
 */
const ContactLink = ({
  children = 'Schedule Your Meeting',
  style,
  className
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = e => {
    e.preventDefault();
    setModalOpen(true);
  };

  return (
    <>
      <a
        href='#contact'
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          ...style
        }}
        className={className}
        aria-label='Open contact modal to schedule a meeting'
      >
        {children}
      </a>
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default ContactLink;
